import { onBeforeUnmount, onMounted, ref } from 'vue'

/**
 * "Has the page scrolled past the top?" with **no scroll listener at all**.
 *
 * A scroll handler runs on every scroll event and, because it wrote to a
 * reactive ref the header renders from, dragged a Vue re-render and a
 * backdrop-filter style recalculation into the scroll frame. That is what
 * showed up in the profile as long tasks attributed to this file.
 *
 * A one-pixel sentinel at the top of the document does the same job: the
 * browser tells us once when it leaves the viewport and once when it comes
 * back. Two callbacks per session instead of hundreds per second.
 */
const scrolled = ref(false)

/** Called once, by the component that renders the sentinel element. */
export function useTopSentinel() {
  const sentinel = ref(null)
  let observer = null

  onMounted(() => {
    if (!sentinel.value || typeof IntersectionObserver === 'undefined') return
    observer = new IntersectionObserver(
      ([entry]) => {
        scrolled.value = !entry.isIntersecting
      },
      { threshold: 0 }
    )
    observer.observe(sentinel.value)
  })

  onBeforeUnmount(() => {
    observer?.disconnect()
    observer = null
  })

  return { sentinel }
}

/** Read-only flag for any component that needs it. */
export function useScrolledPast() {
  return scrolled
}
